import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TermsService } from 'src/app/home/services/terms.service';
import { IdpService } from '../services/auth.service';

export const termsGuard: CanActivateFn = async (route, state) => {
  const router = inject(Router);
  const termsService = inject(TermsService);
  const idpService = inject(IdpService);

  const currentUrl = state?.url || '';

  
  const saveReturnUrlIfNeeded = () => {
    if (currentUrl && currentUrl !== '/' && !currentUrl.includes('terminos')) {
      sessionStorage.setItem('returnUrl', currentUrl);
    }
  };

  try {
    const userProfile = await idpService.loadUserProfileAsync();
    
    if (!userProfile) {
      saveReturnUrlIfNeeded();
      return true;
    }
      
    const data = await termsService.getTermsConditionUser();
    // Simplificamos la verificación usando Optional Chaining
    const tieneTerminos = data && Object.keys(data).length > 0;

    // CASO 1: El usuario NO tiene los términos aceptados
    if (!tieneTerminos) {
      if (currentUrl.includes('terminos')) {
        return true;
      }
      saveReturnUrlIfNeeded();
      router.navigate(['/terminos']);
      return false;
    }

    // CASO 2: El usuario SÍ tiene los términos aceptados
    const returnUrl = sessionStorage.getItem('returnUrl');
    
    if (returnUrl && returnUrl !== currentUrl && !currentUrl.includes('terminos')) {
      sessionStorage.removeItem('returnUrl');
      router.navigateByUrl(returnUrl);
     
      
      return false;
    }
    
    if (currentUrl.includes('home') || currentUrl === '/') {
      router.navigate(['/welcome']);
     
      return false;
    }
    
    return true;

  } catch (error) {
    return true; 
  }
};